import getters from './getters'
import actions from './actions'
import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: getters,
  staticActions: actions,
  schema:  schema
};
